import { PublicPlan } from '@wix/ambassador-pricing-plans-v2-plan/types';
import { Plan } from '@wix/ambassador-pricing-plans-v3-plan/types';

export function orderPlansForMobileView(plans: PublicPlan[] | Plan[], highlightedId: string): PublicPlan[] | Plan[] {
  // Needed due to TS limitations and how .filter works. Will be cleaned up soon enough
  const allPlans = plans as (PublicPlan | Plan)[];
  const highlightedIndex = allPlans.findIndex((plan) => plan.id === highlightedId);
  if (highlightedIndex > 0) {
    const highlightedPlan = allPlans[highlightedIndex];
    return [highlightedPlan, ...allPlans.filter((plan) => plan !== highlightedPlan)] as PublicPlan[] | Plan[];
  }

  return plans;
}
